// we are using these pages in location management as well, so we extracted the paths here so that the code is linked via this constant and updates to one don't break the other.
export const addressValidationPaths = {
  addressForm: 'address-form',
  validationResults: 'validation-results',
  confirmation: 'confirmation',
  timeZone: 'time-zone',
  datePicker: 'date-picker',
  overview: 'overview'
} as const
